export default __webpack_public_path__ + "static/media/2011.b356cf9f.png";